export default __webpack_public_path__ + "static/media/app_stitcher.12f9a296.svg";